
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { TokenDataDto_$reflection, RequestedValue$1_$reflection, CustomerConfiguration_$reflection, FormState_$reflection } from "../Shared/Shared.js";
import { union_type, string_type, class_type, record_type, list_type, option_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ImportHistoryEntry_$reflection } from "../Shared/Importer.js";

export class State extends Record {
    constructor(FormState, CustomerConfiguration, ImportHistory, TokenData) {
        super();
        this.FormState = FormState;
        this.CustomerConfiguration = CustomerConfiguration;
        this.ImportHistory = ImportHistory;
        this.TokenData = TokenData;
    }
}

export function State_$reflection() {
    return record_type("Importer.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["CustomerConfiguration", option_type(CustomerConfiguration_$reflection())], ["ImportHistory", RequestedValue$1_$reflection(list_type(ImportHistoryEntry_$reflection()))], ["TokenData", TokenDataDto_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchImportHistory", "ImportHistoryFetched", "CustomerConfigurationFetched", "ExportSpecificTools", "ExportSimpleTools", "ExportConsumables", "ExportSets", "ExportExcelFetched", "BlobReceived", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.Types.Msg", [], Msg, () => [[], [["Item", list_type(ImportHistoryEntry_$reflection())]], [["Item", CustomerConfiguration_$reflection()]], [], [], [], [], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

